import React from "react";
import ReactDOM from "react-dom";
import { Router, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import moment from "moment";
import localization from "moment/locale/ru";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import App from "./App";
import createAppStore from "./store/store";
import createHistory from "./common/history";
import ErrorBoundary from "./common/hoc/ErrorBoundary";

moment.updateLocale("ru", localization);

const store = createAppStore();
const recaptchaKey = process.env.REACT_APP_RECAPTCHA_KEY;

//Временный костыль редирект на мобильную версию сайта
document.addEventListener("resize", function() {
  if (window.outerWidth < 1200) {
    window.location.assign("https://m.teleportos.ru");
  }
});

ReactDOM.render(
  <Router history={createHistory}>
    <Provider store={store}>
      <GoogleReCaptchaProvider
        reCaptchaKey={recaptchaKey}
        useRecaptchaNet={true}
      >
        <ErrorBoundary>
          <App />
        </ErrorBoundary>
      </GoogleReCaptchaProvider>
    </Provider>
  </Router>,
  document.getElementById("mainFrame")
);
